module.exports = "---\nsummary: Container for an array of float values.\nfields:\n  values:\n    summary: The float values.\n---\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./src/reference/content/happyco.type.v1/FloatArray/overview.md
// module id = 249
// module chunks = 0